import React from 'react';
import Layout from '../../components/Layout';
import Tags from './Tags';
import { logError } from '../../utils/logger';
import { parsePageIndex } from '../../utils/pagination';

const title = 'Tags';

async function action(context) {
  const { id, tag } = context.params;
  const { page: pageIdx } = context.query;
  const pageSize = 10;

  const newsResp = await context.fetch('/graphql', {
    body: JSON.stringify({
      query: `
      query Tags($currentIndex: Int, $pageSize: Int, $publications: String, $tags: String) {
        news(currentIndex: $currentIndex, pageSize: $pageSize, publications: $publications, tags: $tags, active: true) {
          items {
            title date id author blurb blurb_image_uid blurb_expanded_image_uid
            article article_image_uid article_expanded_image_uid article_image_caption
            publications tags category
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            totalCount
            totalPages
            currentIndex
          }
        }
      }
      `,
      variables: {
        currentIndex: parsePageIndex(pageIdx, pageSize) * pageSize,
        pageSize,
        publications: id || null,
        tags: tag,
      },
    }),
  });

  const payload = await newsResp.json();
  const news = payload && payload.data && payload.data.news;
  if (!news) {
    logError(new Error('tags route: GraphQL returned no data'), {
      context: 'routes/tags',
      tag,
      publication: id,
      errors: payload && payload.errors,
    });
    return { redirect: '/not-found' };
  }
  return {
    chunks: ['tags'],
    title,
    component: (
      <Layout>
        <Tags
          tag={tag}
          news={news.items}
          publication={id}
          pageInfo={news.pageInfo} // passing pageInfo in order to render next/previous page controller
          currentPageIdx={parsePageIndex(pageIdx, pageSize)}
          pageSize={pageSize}
        />
      </Layout>
    ),
  };
}

export default action;
